<template>
	<StandardModal
		data-context="MicroFeedbackRadioFormModal"
		data-test="micro-feedback-radio-modal"
		@modal-close="close"
	>
		<template #title>
			<h3 class="heading-5">{{ microfeedbackModalTitle }}</h3>
		</template>
		<template #content>
			<MicroFeedbackRadioForm
				:associated-event-id="associatedEventId"
				:micro-feedback-event-type="microFeedbackEventType"
				:pre-selected-response="preSelectedResponse"
				:distinct-id="distinctId"
				:handle-redirect="false"
				:micro-feedback-form-title="microfeedbackFormTitle"
				:micro-feedback-form-subtitle="microfeedbackFormSubtitle"
				:display-form-subtitle="displayFormSubtitle"
				@feedback-form-submitted="close"
			/>
		</template>
	</StandardModal>
</template>

<script setup lang="ts">
import { MicroFeedbackReactionType, MicroFeedbackType } from 'types/micro-feedback';
import { computed } from 'vue';
import { getDistinctId } from '@utils/analytics';
import MicroFeedbackRadioForm from '@components/micro-feedback/micro-feedback-radio-form.vue';
import StandardModal from '@components/modals/standard-modal.vue';
interface Props {
	associatedEventId?: string;
	microFeedbackEventType: MicroFeedbackType;
	preSelectedResponse?: MicroFeedbackReactionType;
	microfeedbackModalTitle?: string;
	microfeedbackFormTitle?: string;
	microfeedbackFormSubtitle?: string;
	displayFormSubtitle?: boolean;
}

withDefaults(defineProps<Props>(), {
	associatedEventId: undefined,
	preSelectedResponse: 'NEUTRAL',
	microfeedbackModalTitle: 'Share your feedback',
	microfeedbackFormTitle: 'How would you rate your overall satisfaction with this experience?',
	microfeedbackFormSubtitle: 'Tell us more about your rating.',
	displayFormSubtitle: true
});
interface Emits {
	(e: 'modal-close'): void;
}
const emit = defineEmits<Emits>();

const distinctId = computed((): string | undefined => {
	return getDistinctId();
});

function close(): void {
	emit('modal-close');
}
</script>

<style lang="scss" scoped>
:deep(.radio-checkbox-item .mask:before) {
	animation: none !important;
}
</style>
